import { render, staticRenderFns } from "./JoinLogin.vue?vue&type=template&id=d6f07f8a&scoped=true"
import script from "./JoinLogin.vue?vue&type=script&lang=js"
export * from "./JoinLogin.vue?vue&type=script&lang=js"
import style0 from "./JoinLogin.vue?vue&type=style&index=0&id=d6f07f8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f07f8a",
  null
  
)

export default component.exports